import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

export default function Hero() {
  return (
    <section className="hero" aria-label="Hero">
      <div className="hero-bg" aria-hidden="true">
        <div className="hero-shape hero-shape-1" />
        <div className="hero-shape hero-shape-2" />
        <div className="hero-shape hero-shape-3" />
        <div className="hero-dots" />
      </div>

      <div className="hero-content">
        <div className="container">
          <div className="hero-inner">
            <div className="hero-text">
              <div className="hero-badge">
                <span className="hero-badge-dot" aria-hidden="true" />
                Registered NGO &bull; Est. 2010
              </div>

              <h1 className="hero-title">
                Lighting Lives,{' '}
                <span className="hero-title-highlight">Empowering</span>{' '}
                Communities
              </h1>

              <p className="hero-description">
                Shine People Trust works tirelessly to bring quality education, healthcare, and sustainable livelihoods to underserved communities across India — because every person deserves to shine.
              </p>

              <div className="hero-actions">
                <a href="https://grantalife.com/" target="_blank" rel="noopener noreferrer" className="btn btn-secondary btn-lg">
                  Get Involved &rarr;
                </a>
                <Link to="/programs" className="btn btn-outline-white btn-lg">
                  Our Programs
                </Link>
              </div>

              <div className="hero-stats-inline" role="list" aria-label="Key statistics">
                <div className="hero-stat-item" role="listitem">
                  <div className="hero-stat-number">50,000+</div>
                  <div className="hero-stat-label">Lives Touched</div>
                </div>
                <div className="hero-stat-divider" aria-hidden="true" />
                <div className="hero-stat-item" role="listitem">
                  <div className="hero-stat-number">120+</div>
                  <div className="hero-stat-label">Villages Served</div>
                </div>
                <div className="hero-stat-divider" aria-hidden="true" />
                <div className="hero-stat-item" role="listitem">
                  <div className="hero-stat-number">15+</div>
                  <div className="hero-stat-label">Years of Impact</div>
                </div>
              </div>
            </div>

            <div className="hero-visual">
              <div className="hero-image-stack">
                <div className="hero-img-wrap">
                  <img
                    src="https://images.unsplash.com/photo-1511632765486-a01980e01a18?auto=format&fit=crop&w=600&h=750&q=80"
                    alt="Community members working together in a village development program"
                    className="hero-img-main"
                    loading="eager"
                  />
                  <div className="hero-img-overlay" aria-hidden="true" />
                </div>

                <div className="hero-float-card hero-float-card-1" aria-hidden="true">
                  <div className="float-card-icon float-card-icon-teal">🎓</div>
                  <div>
                    <div className="float-card-num">8,500+</div>
                    <div className="float-card-lbl">Children Educated</div>
                  </div>
                </div>

                <div className="hero-float-card hero-float-card-2" aria-hidden="true">
                  <div className="float-card-icon float-card-icon-amber">❤️</div>
                  <div>
                    <div className="float-card-num">12,000+</div>
                    <div className="float-card-lbl">Health Checkups</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hero-scroll" aria-hidden="true">
        <span className="hero-scroll-text">Scroll</span>
        <div className="scroll-mouse">
          <div className="scroll-wheel" />
        </div>
      </div>
    </section>
  );
}
